import React from 'react';
import Text from 'components/Text/Text';
import { TTextTranslationNamespaces } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import DOMPurify from 'dompurify';
import { TOptions } from 'i18next';
import classNames from 'classnames';
import style from './FullInfoField.module.scss';

interface IProps {
	label?: string | null;
	value?: string | number | null;
	containerClassName?: string;
	inputWrapperClassName?: string;
	className?: string;
	translationNameSpace?: TTextTranslationNamespaces;
	withXSSSecurity?: boolean;
	translationOptions?: TOptions | string;
	prefixIcon?: 'asCheckbox' | 'asSelect';
	prefixIconName?: string;
	prefixIconIsChecked?: boolean;
	useInForm?: boolean;
	childrenContent?: React.ReactNode;
}

const FullInfoField: React.FC<IProps> = ({
	label,
	value,
	containerClassName,
	inputWrapperClassName,
	className,
	translationNameSpace,
	withXSSSecurity = false,
	translationOptions,
	prefixIcon,
	prefixIconName,
	prefixIconIsChecked,
	useInForm = false,
	childrenContent,
}) => {
	const containerClasses = classNames(style.container, { [style.containerUseUnForm]: useInForm }, containerClassName);
	const htmlWrapperClasses = classNames(style.htmlWrapper, style.border, { [style.wrapperUseInForm]: useInForm });
	const inputWrapperClasses = classNames(
		style.inputWrapper,
		style.border,
		{ [style.wrapperUseInForm]: useInForm },
		inputWrapperClassName,
	);
	const inputClasses = classNames(style.input, className);
	const iconClasses = classNames(style.icon, {
		[style.iconAsSelect]: prefixIcon === 'asSelect',
		[style.iconChecked]: prefixIconIsChecked === true,
		[style.iconUnchecked]: prefixIconIsChecked === false,
	});

	return (
		<div className={containerClasses} data-test={label}>
			{(label || label === null) && (
				<Text
					translationNameSpace={translationNameSpace || 'form'}
					translationKey={label}
					theme="neutralLight"
					size="xs"
					translationOptions={translationOptions}
				/>
			)}
			{withXSSSecurity && (
				<div
					className={htmlWrapperClasses}
					dangerouslySetInnerHTML={{ __html: value ? DOMPurify.sanitize(String(value)) : '-' }}
				/>
			)}
			{!withXSSSecurity && (value || value === 0 || value === '' || value === null || childrenContent) && (
				<div className={inputWrapperClasses}>
					{prefixIcon && (
						<svg className={iconClasses}>
							<use xlinkHref={`${breadcrumbs}#${prefixIconName}`} />
						</svg>
					)}
					{childrenContent ? (
						childrenContent
					) : (
						<Text
							className={inputClasses}
							translationNameSpace={translationNameSpace}
							translationKey={typeof value === 'number' ? String(value) : value}
							withTooltip={true}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default React.memo(FullInfoField);
